export type ImageAlignment = "left" | "center" | "right";

/** Lexical 节点 `getType()` 与序列化 JSON 的 `type` 字段 */
export const LEXICAL_IMAGE_BLOCK_TYPE = "image-block" as const;

/**
 * 相对原图自然尺寸的归一化裁切视窗（0–1），左上 + 宽高。
 * 不修改 `src`，正文用 cover 思路（缩放 + overflow 裁切）只显示该区域。
 */
export type ImageCropRectNorm = {
  x: number;
  y: number;
  w: number;
  h: number;
};

export type SerializedImageBlockNodeV1 = {
  type: typeof LEXICAL_IMAGE_BLOCK_TYPE;
  version: 1;
  src: string;
  alt: string;
  caption: string;
  alignment: ImageAlignment;
  openPickerOnMount: boolean;
  /** 相对正文内容区宽度的显示百分比，默认 50 */
  widthPercent?: number;
  /** 归一化裁切框；缺省表示整图展示 */
  cropNorm?: ImageCropRectNorm | null;
};
